import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import './settings.css'
import { Context } from "../../context/Context";
import BottomNav from '../../components/bottomnav/BottomNav';
import axios from "axios"
import Avatar from 'react-avatar';
import ProgressBar from '../../components/progressbar/ProgressBar';
import Navbar from '../../components/navbar/Navbar';
import { Notify} from "notiflix";

function Settings() {
    const {user, dispatch} = useContext(Context);
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [loadingPerc, setloadingPerc] = useState(0);
    
    const api_uri = "https://mentorxfa.herokuapp.com/api";   

    Notify.init({
        position: 'right-top'
    })

    const updateConfig = {
        onUploadProgress: progressEvent => {

            let perCompleted = Math.floor((progressEvent.loaded / progressEvent.total) *100 )
            setloadingPerc(perCompleted);
        }
    }

    useEffect(() => {
        setUsername(user.username);  
        setEmail(user.email)         
    }, [user.email, user.username])

    const handleSubmit = async (e)=>{
        e.preventDefault();
        setIsLoading(true)        
        dispatch({type:"UPDATE_START"});
        const updatedUser = {
            userId: user._id,
            username,
            email,
            password
        }
        try {
            const res = await axios.put(api_uri+"/users/"+ user._id, updatedUser,updateConfig);                  
            dispatch({type:"UPDATE_SUCCESS", payload: res.data});
            setTimeout(() => {
                setIsLoading(false)
                Notify.success('Settings Updated Successfully');
            }, 300)
        } catch (err) {
            console.log(err);
            dispatch({type:"UPDATE_FAILURE"});
            Notify.failure('Error updating settings');
        }
    }

    const handleLogout = () => {
        setTimeout(() => {
            dispatch({type: "LOGOUT"});
            Notify.success('Logged Out');
        }, 700)
       
    }

    return (
        <>   
        <Navbar/>       
        {
            isLoading && <ProgressBar percentage={loadingPerc}/>
        }
            <div className="settings">           
                <form onSubmit={handleSubmit}>
                    <div className="settings-header">                
                        <span className="settings-title">Settings</span>            
                        <label htmlFor="profile-input" className="settings-profile">
                        <Avatar name={user.username} size="75" round={true} textSizeRatio={2.5} />
                            {/* <img src="https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" alt="" /> */}
                        </label>
                        {/* <input type="file" id="profile-input" style={{display:"none"}} /> */}
                    </div>
                    <div className="settings-info">
                        <input type="text" className="settings-input" value={username} onChange={e => setUsername(e.target.value)} />
                        <input type="text" className="settings-input" value={email} onChange={e => setEmail(e.target.value)} />
                        <input type="password" className="settings-input" placeholder="Password" onChange={e => setPassword(e.target.value)} />            
                        <button className="settings-update-btn" type="submit">Update</button>
                    </div>
                    {/* <div className="settings-error">
                        {success && <span>Profile has been updated</span> }
                    </div> */}
                                  
                </form>     
                <div className="logout">
                        <button onClick={handleLogout} className="logout-btn">Logout</button>
                        {
                            user && user.role === "masterAdmin" && <Link to="/admin" >
                            <button className="to-admin-btn">Go to Admin</button>
                        </Link>
                        }
                </div>             
            </div>
        <BottomNav/>
        </>
    )
}

export default Settings
